<template>
    <v-row no-gutters>
        <v-col cols="12" class="pa-2">
            <div
                style="background: #fff; overflow: hidden"
                class="rounded-lg d-flex align-center justify-space-between"
            >
                <v-tabs v-model="type" background-color="white" width="100%" fixed-tabs>
                    <v-tab value="ALL" class="px-3">
                        <span class="hidden-sm-and-down">Tous</span>
                    </v-tab>

                    <v-tab value="BANK" class="px-3">
                        <span class="hidden-sm-and-down">Banque</span>
                    </v-tab>

                    <v-tab value="MAIL" class="px-3">
                        <span class="hidden-sm-and-down">Mail</span>
                    </v-tab>

                    <v-tab value="PAYMENT" class="px-3">
                        <span class="hidden-sm-and-down">Paiement</span>
                    </v-tab>

                    <v-tab value="OTHER" class="px-3">
                        <span class="hidden-sm-and-down">Autre</span>
                    </v-tab>
                </v-tabs>
                <div style="width: 30%" class="pr-1">
                    <v-text-field-filled
                        v-model="search"
                        append-inner-icon="$search"
                        clearable
                        label="Rechercher"
                        outlined
                        dense
                        hide-details
                    />
                </div>
            </div>
        </v-col>
    </v-row>
    <v-row no-gutters>
        <!-- <v-col cols="4" v-if="display('setting-task')" class="d-flex">
            <setting-task ref="setting-task" :config="config" @updateProfile="updateProfile()" />
        </v-col> -->
        <v-col cols="4" v-if="display('setting-document-from-mail')" class="d-flex my-2">
            <setting-document-from-mail
                ref="setting-document-from-mail"
                :config="config"
                :profileId="profileId"
                :companyId="companyId"
                @updateProfile="updateProfile()"
                @onUpdate="refresh"
            />
        </v-col>
        <v-col cols="4" v-if="display('setting-payment')" class="d-flex my-2">
            <setting-payment
                ref="setting-payment"
                :config="config"
                :companyId="companyId"
                @updateProfile="updateProfile()"
            />
        </v-col>
        <v-col cols="4" v-if="display('setting-accounting-mail')" class="d-flex my-2">
            <setting-accounting-mail
                ref="setting-accounting-mail"
                :config="config"
                :profileId="profileId"
                :companyId="companyId"
                @updateProfile="updateProfile()"
                @onUpdate="refresh"
            />
        </v-col>
        <!-- <v-col cols="4" v-if="display('setting-sending-mail-smtp')" class="d-flex">
            <SettingSendingMailSMTP
                ref="setting-sending-mail-smtp"
                :config="config"
                :profileId="profileId"
                :companyId="companyId"
                @updateProfile="updateProfile()"
                @onUpdate="refresh"
            ></SettingSendingMailSMTP>
        </v-col> -->
        <v-col cols="4" v-if="display('setting-je-declare')" class="d-flex my-2">
            <setting-je-declare
                ref="setting-je-declare"
                :config="config"
                :JDCConnectionOnTest="JDCConnectionOnTest"
                :JDCConnectionTestSuccess="JDCConnectionTestSuccess"
                @updateProfile="updateProfile()"
            />
        </v-col>
        <v-col cols="4" v-if="display('setting-sobank')" class="d-flex my-2">
            <setting-sobank
                ref="setting-sobank"
                :config="config"
                :JDCConnectionOnTest="JDCConnectionOnTest"
                :JDCConnectionTestSuccess="JDCConnectionTestSuccess"
                @updateProfile="updateProfile()"
            />
        </v-col>
        <v-col cols="4" v-if="display('setting-expense-and-income')" class="d-flex my-2">
            <SettingExpenseAndIncome
                ref="setting-expense-and-income"
                :config="config"
                @updateProfile="updateProfile()"
            />
        </v-col>
    </v-row>
</template>

<script lang="ts">
import { User } from "../../store/store";
import { cloneDeep } from "lodash";

import SettingTask from "../configuration/settings/SettingTask.vue";
import SettingExpenseAndIncome from "../configuration/settings/SettingExpenseAndIncome.vue";
import SettingDocumentFromMail from "../configuration/settings/SettingDocumentFromMail.vue";
// import SettingDeclaration from "../configuration/settings-old/SettingDeclaration.vue";
import SettingOthers from "../configuration/settings-old/SettingOthers.vue";
import SettingPayment from "../configuration/settings-old/SettingPayment.vue";
import SettingAccountingMail from "../configuration/settings/SettingAccuntingMail.vue";
import SettingJeDeclare from "../configuration/settings/SettingJeDeclare.vue";
import SettingSobank from "../configuration/settings/SettingSoBank.vue";
import SettingSendingMailSMTP from "../configuration/settings/SettingSendingMailSMTP.vue";

import AccountingConfigAPI from "./AccountingConfigAPI.vue";

import { Apollo } from "@/decorators";

import PROFILE_COMPANY from "../../graphql/company/ProfileCompany.gql";
import UPSERT_PROFILE_COMPANY from "../../graphql/UpsertProfileCompany.gql";

import { updateStoreUser } from "../../services/userServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

@Component({
    components: {
        SettingTask,
        SettingExpenseAndIncome,
        SettingDocumentFromMail,
        // SettingDeclaration,
        SettingOthers,
        SettingPayment,
        SettingAccountingMail,
        SettingJeDeclare,
        SettingSendingMailSMTP,
        SettingSobank,
        AccountingConfigAPI,
    },
})
export class ConfigAPI2 extends Vue {
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: "" }) inProfileId: string;
    @Prop({ default: "Client" }) mode: string;

    vueUpdatePassword: boolean = false;
    mailUsage: string = "";
    index: number = -1;
    JDCConnectionTestSuccess: any = null;
    JDCConnectionOnTest: boolean = false;

    search = "";

    type: string = "ALL";

    get currentUser(): User {
        return this.$store.state.user;
    }

    profileId_ = "";

    get profileId() {
        if (this.profileId_) {
            return this.profileId_;
        }
        return this.inProfileId;
    }

    get readonly() {
        // ready for MAJ with mode 'Client'
        if (this.mode === "Client") {
            return (
                this.companyId === this.$store.state.user.company.id &&
                this.$store.state.user.company.accountingFirm
            );
        }
        return false;
    }

    @Watch("profileId")
    setConfig() {
        if (this.profileId === undefined) {
            this.config = JSON.stringify(this.defaultConfig);
        }
    }

    @Apollo({
        query: PROFILE_COMPANY,
        variables() {
            return {
                id: this.profileId,
            };
        },
        skip() {
            return !this.profileId;
        },
        fetchPolicy: "network-only",
        specificResult({ data, loading, networkStatus }: any) {
            this.genericLoading_db = loading;
            if (!loading) {
                if (data && data.profileCompany) {
                    debugger;
                    const tempoConfig = data.profileCompany;
                    // const tempoConfig = JSON.parse(JSON.stringify(data.profileCompany))
                    // debugger
                    // if (!tempoConfig.gmailConfig) {
                    //     tempoConfig.gmailConfig = {
                    //         users: []
                    //     }
                    // }
                    if (!tempoConfig.accountingMailConfig) {
                        tempoConfig.accountingMailConfig = {
                            users: [],
                        };
                    }
                    if (!tempoConfig.ogaEnrolmentConfig) {
                        tempoConfig.ogaEnrolmentConfig = {
                            numberId: "",
                            siret: "",
                            designation: "",
                            address: "",
                            postalCode: "",
                            city: "",
                            year: "",
                        };
                    }
                    if (!tempoConfig.stripeConfig) {
                        tempoConfig.stripeConfig = undefined;
                    }
                    if (!tempoConfig.mollieConfig) {
                        tempoConfig.mollieConfig = undefined;
                    }
                    if (!tempoConfig.documentFromMailConfig) {
                        tempoConfig.documentFromMailConfig = {
                            users: [],
                        };
                    }
                    if (!tempoConfig.sendingMailSMTPConfig) {
                        tempoConfig.sendingMailSMTPConfig = {
                            users: [],
                        };
                    }
                    if (!tempoConfig.vatBankAccount) {
                        tempoConfig.vatBankAccount = { id: null };
                    }
                    if (!tempoConfig.accountingType) {
                        tempoConfig.accountingType = "RECEIVABLES_DEBT";
                    }
                    if (!tempoConfig.jeDeclareDotComConfig) {
                        tempoConfig.jeDeclareDotComConfig = {
                            auth: {
                                username: "",
                                password: "",
                            },
                        };
                    } else {
                        tempoConfig.jeDeclareDotComConfig.auth.password = "";
                    }
                    if (
                        tempoConfig.paymentCreditCount === null ||
                        tempoConfig.paymentCreditCount === undefined
                    ) {
                        tempoConfig.paymentCreditCount = 0;
                    }
                    debugger;
                    if (!tempoConfig.rofs || !tempoConfig.rofs.length) {
                        tempoConfig.rofs = [
                            {
                                tax: "TVA",
                                rof: "1",
                            },
                            {
                                tax: "IS",
                                rof: "1",
                            },
                            {
                                tax: "CVAE",
                                rof: "1",
                            },
                            {
                                tax: "CFE",
                                rof: "1",
                            },
                            {
                                tax: "RCM",
                                rof: "1",
                            },
                        ];
                    }
                    if (!tempoConfig.stockConfig) {
                        tempoConfig.stockConfig = undefined;
                    }
                    this.config = tempoConfig;
                } else {
                    this.config = JSON.stringify(this.defaultConfig);
                }
            }
        },
    })
    defaultConfig: any = {
        //don't forget to modify config in apollo when you modify this Json
        accountingType: "RECEIVABLES_DEBT",
        createZTillReceipt: true,
        zTillReceiptWithTransactions: false,
        createExpenseReport: true,
        createPaySlip: true,
        createSalesInvoice: true,

        taxeApprentissage: false,
        taxeSurLesSalaires: false,
        contributionUniqueALaFormation: false,
        contributionEffortConstruction: false,

        stripeManual: false,
        stripeAuto: false,
        stripeConfig: {
            key: "",
        },

        mollieManual: false,
        mollieAuto: false,
        mollieConfig: {
            key: "",
        },

        ogaEnrolment: false,
        ogaEnrolmentConfig: {
            numberId: "",
            siret: "",
            designation: "",
            address: "",
            postalCode: "",
            city: "",
            year: "",
        },

        // gmail: false,
        // gmailConfig: {
        //     users: []
        // },

        accountingMail: false,
        accountingMailConfig: {
            users: [],
        },

        documentFromMail: false,
        documentFromMailConfig: {
            users: [],
        },

        sendingMailSMTP: false,
        sendingMailSMTPConfig: {
            users: [],
        },

        vatBankAccount: {
            id: null,
            name: null,
        },

        jeDeclareDotCom: false,
        jeDeclareDotComConfig: {
            auth: {
                username: "",
                password: "",
            },
        },
        rofs: [],
        paymentCreditCount: 0,
        activateTask: false,
        autoTaxTask: false,
        autoVATTask: false,

        stock: false,
        stockConfig: undefined,

        managementAuthorization: true,
        managementAuthorizations: {
            supplier: true,
            client: true,
            expenseReport: true,
            salary: true,
            operatingAccount: true,
            selectedClient: true,
        },

        mailCollectKey: null,
        mailCollect: false,
    };

    config = cloneDeep(this.defaultConfig);

    async updateProfile() {
        const result = await this.$apollo.mutate({
            mutation: UPSERT_PROFILE_COMPANY,
            variables: {
                ...this.config,
                companyId: this.companyId,
                id: this.profileId || "",
            },
        });
        // debugger // git-ignore
        if (this.inProfileId && this.inProfileId !== result.data.upsertProfileCompany.id) {
            debugger;
        }
        this.profileId_ = result.data.upsertProfileCompany.id;

        this.config.jeDeclareDotComConfig = result.data.upsertProfileCompany.jeDeclareDotComConfig;
        if (this.config.jeDeclareDotComConfig?.auth?.password) {
            this.config.jeDeclareDotComConfig.auth.password = null;
        }
        if (!this.config.jeDeclareDotComConfig?.error) {
            this.JDCConnectionTestSuccess = true;
        } else {
            this.JDCConnectionTestSuccess = false;
        }
        this.JDCConnectionOnTest = false;
        setTimeout(() => (this.JDCConnectionTestSuccess = false), 1000);
        await updateStoreUser(this.$apollo, this.$store, this.currentUser.id);
    }

    refresh() {
        if (this.$apollo.queries && this.$apollo.queries.config) {
            this.$apollo.queries.config.refetch();
        } else {
            debugger; // git-ignore
        }
    }

    display(setting) {
        switch (setting) {
            case "setting-task":
                return ["ALL", "OTHER"].includes(this.type);

            case "setting-document-from-mail":
                return ["ALL", "MAIL"].includes(this.type);

            case "setting-accounting-mail":
                return ["ALL", "MAIL"].includes(this.type) && this.mode === "Accounting";

            case "setting-payment":
                return ["ALL", "PAYMENT"].includes(this.type) && this.mode === "Accounting";

            case "setting-sending-mail-smtp":
                return ["ALL", "MAIL", "INVOICE"].includes(this.type) && this.mode === "Accounting";

            case "setting-je-declare":
                return ["ALL", "BANK"].includes(this.type) && this.mode === "Accounting";

            case "setting-sobank":
                return ["ALL", "BANK"].includes(this.type) && this.mode === "Accounting";

            case "setting-expense-and-income":
                return ["ALL", "OTHER"].includes(this.type) && this.mode === "Client";

            case "setting-declaration":
                return ["ALL", "OTHER"].includes(this.type) && this.mode === "Client";

            case "setting-generic":
                return ["ALL", "OTHER"].includes(this.type);

            default:
                return ["ALL", "OTHER"].includes(this.type);
        }
    }
}

export default toNative(ConfigAPI2);
</script>
